import { GraphQLClient, ClientError } from 'graphql-request';
import type { RequestDocument, Variables } from 'graphql-request';
import { getMobietrainApiUrl } from './config';
import { clearMobietrainToken, fetchMobietrainToken } from './token';

export const mobietrainGraphql = async <T, V extends Variables = Variables>(
  document: RequestDocument,
  variables?: V,
): Promise<T> => {
  const token = await fetchMobietrainToken();
  const endpoint = `${getMobietrainApiUrl()}/graphql`;
  const client = new GraphQLClient(endpoint, {
    headers: { authorization: `Bearer ${token}` },
  });
  try {
    return await client.request<T>(document, variables);
  } catch (err) {
    if (err instanceof ClientError && err.response.status === 401) {
      clearMobietrainToken();
    }
    throw err;
  }
};
